'use client';

import { homeMeta, blurActiveElement } from '@/utils';

import { Meta } from '../segments';

import Converters from './Converters';

const Home = () => {
  return (
    <>
      <Meta {...homeMeta} />

      <main>
        <section className="py-4">
          <div className="container">
            <div className="text-center mb-4">
              <h1 className="mb-2">
                Transfer Playlists Between Music Platforms
              </h1>

              <p className="text-muted mb-0">
                Transfer your playlists across platforms like Spotify, Apple
                Music, and YouTube Music.
              </p>
            </div>

            <Converters />
          </div>
        </section>

        {/* Supported Platforms */}
        <section className="pt-4">
          <div className="container">
            <div className="content-separator"></div>
            <div className="text-center">
              <h2 className="mb-4">Supported Platforms</h2>
              <p className="text-muted mb-5">
                Transfer your playlists between these music streaming platforms
              </p>

              <div className="row justify-content-center">
                <div className="col-lg-3 col-md-6 col-sm-6 mb-4">
                  <div className="platform-card h-100 d-flex">
                    <div className="card-body d-flex flex-column align-items-center justify-content-center p-4">
                      <span
                        aria-hidden="true"
                        style={{ height: '1.2rem' }}
                        className="d-block d-md-none"
                      />
                      <img
                        alt="Spotify"
                        loading="eager"
                        decoding="async"
                        style={{
                          width: '8.5rem',
                          height: 'auto',
                          display: 'block',
                        }}
                        src="/brand/spotify/logo.svg"
                      />
                      <span
                        aria-hidden="true"
                        style={{ height: '1.2rem' }}
                        className="d-block d-md-none"
                      />
                    </div>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-sm-6 mb-4">
                  <div className="platform-card h-100 d-flex">
                    <div className="card-body d-flex flex-column align-items-center justify-content-center p-4">
                      <span
                        aria-hidden="true"
                        style={{ height: '1.2rem' }}
                        className="d-block d-md-none"
                      />
                      <img
                        alt="YouTube"
                        loading="eager"
                        decoding="async"
                        style={{
                          width: '8.5rem',
                          height: 'auto',
                          display: 'block',
                        }}
                        src="/brand/youtube/logo.svg"
                      />
                      <span
                        aria-hidden="true"
                        style={{ height: '1.2rem' }}
                        className="d-block d-md-none"
                      />
                    </div>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-sm-6 mb-4">
                  <div className="platform-card h-100 d-flex">
                    <div className="card-body d-flex flex-column align-items-center justify-content-center p-4">
                      <span
                        aria-hidden="true"
                        style={{ height: '1.2rem' }}
                        className="d-block d-md-none"
                      />
                      <img
                        loading="eager"
                        decoding="async"
                        style={{
                          width: '8.5rem',
                          height: 'auto',
                          display: 'block',
                        }}
                        alt="Apple Music"
                        src="/brand/apple/logo.svg"
                      />
                      <span
                        aria-hidden="true"
                        style={{ height: '1.2rem' }}
                        className="d-block d-md-none"
                      />
                    </div>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-sm-6 mb-4">
                  <div className="platform-card h-100 d-flex">
                    <div className="card-body d-flex flex-column align-items-center justify-content-center p-4">
                      <span
                        aria-hidden="true"
                        style={{ height: '1.2rem' }}
                        className="d-block d-md-none"
                      />
                      <h6 className="text-center m-0 text-accent">
                        <b>More Coming Soon</b>
                      </h6>
                      <span
                        aria-hidden="true"
                        style={{ height: '1.2rem' }}
                        className="d-block d-md-none"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* How It Works */}
        <section className="pt-4" id="how-it-works">
          <div className="container">
            <div className="content-separator"></div>
            <div className="text-center">
              <h2 className="mb-4">How It Works</h2>
              <p className="text-muted mb-5">
                Transfer your playlists in a few simple steps
              </p>

              <div className="row">
                <div className="col-md-3 mb-4 mb-md-0">
                  <div
                    className="rounded-circle bg-accent text-white d-flex align-items-center justify-content-center mx-auto mb-4"
                    style={{ width: '60px', height: '60px' }}
                  >
                    <span className="fw-bold">1</span>
                  </div>
                  <h5>Choose Transfer Method</h5>
                  <p className="text-muted">
                    Select your preferred transfer option.
                  </p>
                </div>

                <div className="col-md-3 mb-4 mb-md-0">
                  <div
                    className="rounded-circle bg-accent text-white d-flex align-items-center justify-content-center mx-auto mb-4"
                    style={{ width: '60px', height: '60px' }}
                  >
                    <span className="fw-bold">2</span>
                  </div>
                  <h5>Provide Transfer Details</h5>
                  <p className="text-muted">
                    Enter the required information and sign in as prompted.
                  </p>
                </div>

                <div className="col-md-3 mb-4 mb-md-0">
                  <div
                    className="rounded-circle bg-accent text-white d-flex align-items-center justify-content-center mx-auto mb-4"
                    style={{ width: '60px', height: '60px' }}
                  >
                    <span className="fw-bold">3</span>
                  </div>
                  <h5>Customize Settings</h5>
                  <p className="text-muted">
                    Adjust any available preferences for your transfer.
                  </p>
                </div>

                <div className="col-md-3">
                  <div
                    className="rounded-circle bg-accent text-white d-flex align-items-center justify-content-center mx-auto mb-4"
                    style={{ width: '60px', height: '60px' }}
                  >
                    <span className="fw-bold">4</span>
                  </div>
                  <h5>Complete Transfer</h5>
                  <p className="text-muted">
                    Start the process and review the results.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Features */}
        <section className="pt-4" id="features">
          <div className="container">
            <div className="content-separator"></div>
            <div className="text-center mb-5">
              <h2 className="mb-3">Features</h2>
              <p className="text-muted">Why choose Convert Playlist</p>
            </div>

            <div className="row g-4">
              <div className="col-md-4 mb-4">
                <div className="d-flex">
                  <div className="flex-shrink-0 text-accent me-3">
                    <i className="fas fa-bolt fs-3"></i>
                  </div>
                  <div>
                    <h5>Fast Transfer</h5>
                    <p className="text-muted">
                      Transfer your playlists quickly with our optimized
                      matching algorithm.
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-4 mb-4">
                <div className="d-flex">
                  <div className="flex-shrink-0 text-accent me-3">
                    <i className="fas fa-shield-alt fs-3"></i>
                  </div>
                  <div>
                    <h5>Secure</h5>
                    <p className="text-muted">
                      Your data is encrypted and we never store your passwords.
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-4 mb-4">
                <div className="d-flex">
                  <div className="flex-shrink-0 text-accent me-3">
                    <i className="fas fa-chart-line fs-3"></i>
                  </div>
                  <div>
                    <h5>High Match Rate</h5>
                    <p className="text-muted">
                      Our advanced algorithm ensures the highest possible match
                      rate for your songs.
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-4 mb-4">
                <div className="d-flex">
                  <div className="flex-shrink-0 text-accent me-3">
                    <i className="fas fa-thumbs-up fs-3"></i>
                  </div>
                  <div>
                    <h5>Easy to Use</h5>
                    <p className="text-muted">
                      Simple interface designed for users of all technical
                      levels.
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-4 mb-4">
                <div className="d-flex">
                  <div className="flex-shrink-0 text-accent me-3">
                    <i className="fas fa-gift fs-3"></i>
                  </div>
                  <div>
                    <h5>Free to Use</h5>
                    <p className="text-muted">
                      Currently free with premium features coming soon.
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-4 mb-4">
                <div className="d-flex">
                  <div className="flex-shrink-0 text-accent me-3">
                    <i className="fas fa-sync fs-3"></i>
                  </div>
                  <div>
                    <h5>Future Features</h5>
                    <p className="text-muted">
                      Playlist backup, scheduled transfers, and more coming
                      soon.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="pt-4">
          <div className="container">
            <div className="content-separator"></div>
            <div className="text-center">
              <h2 className="mb-4">Ready to Transfer Your Playlists?</h2>
              <p className="text-muted mb-4">
                Join others already transferring their playlists
              </p>

              <button
                type="button"
                className="btn btn-accent btn-lg px-4"
                onClick={() => {
                  window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
                  blurActiveElement();
                }}
              >
                Get Started
              </button>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default Home;
